import React, { Component } from "react";
import {Link} from "react-router-dom";

const PortfolioListContent = [
    {
        image: '/assets/images/works/work-42.png',
        category: 'Mobile App + Back End (Flutter/GoLang/MongoDB)',
        title: 'rePresence App',
        url: 'represence'
    },
    {
        image: '/assets/images/works/work-41.jpg',
        category: 'Mobile App (Flutter)',
        title: 'Atourin Mobile',
        url: 'atourin'
    },
    {
        image: '/assets/images/works/work-27.png',
        category: 'Mobile App (Android Native)',
        title: 'Halo Browser - Proxy Integrated Browser',
      
    },
    {
        image: '/assets/images/works/work-9.jpg',
        category: 'Experimental Project (Nuxt/Firebase)',
        title: 'Lifeducare',
     
    },

    {
        image: '/assets/images/works/work-30.png',
        category: 'Mobile App (Android Native',
        title: 'Zodiak Corner',
    
    },
    {
        image: '/assets/images/works/work-1.jpg',
        category: 'Front-End Website (Vue.Js)',
        title: 'Quick Count Pilpres - Website',


    }
]

class PortfolioList extends Component{
    render(){
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index} >
                        <div className={`portfolio ${styevariation}`}>
                            <div className="thumbnail-inner">
                                <div className={`thumbnail ${value.image}`} style={{ backgroundImage: `url("${value.image}")`}}></div>
                                <div className={`bg-blr-image ${value.image}`}></div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <p>{value.category}</p>
                                    <h4>{value.title}</h4>
                                    {  value.url != null ? 
                                           <a href={`/projects/${value.url}`}>
                                           <div className="portfolio-button">
                                               <a className="rn-btn" >View Details</a>
                                           </div>
                                   </a> : <span></span>
                                    }
                                    
                                 
                                    
                                </div>
                            </div>
                            {/* <Link className="link-overlay" to="/portfolio-details"></Link> */}
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioList;